import React, {Component} from "react";
import {Form, Input , Radio,Row,Col} from 'antd';
import NHFetch from "../../../utils/NHFetch";

const FormItem = Form.Item;

const baseUrlPath = "/swbl/lstd"; //基础路径

/**
 * 绿色通道查看表单
 * @author admin
 * @date 2018-03-16 11:28:34
 * Version: 1.0
 */
class ViewForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            blyy:'',
            fj:[],
            viewData:[],
            jjlxrData:[]
        }
    }
    componentWillMount(){
        //根据lstdid 获取办理原因
        let initFormData = this.props.initFormData;
        NHFetch(`/swbl/lstd/lstdblyy/${initFormData.PKID}/getBlyyStr`,"get").then(res=>{
            if(res){
                this.setState({blyy:res.data});
            }
        })

        NHFetch(`/swbl/lstd/${initFormData.PKID}/getFjList`,"get").then(res=>{
            if(res){
                this.setState({fj:res.data});
            }
        })
        this.getgxData();
    }

    // 获取关系数据
   getgxData =()=>{
            let params = {
            sign:"dmk_XSXX_JTCYGX" 
            }
        NHFetch('api/zhxg-yxwz/proData/selectDataList', 'GET', params)
        .then(res => {
            if(res && res.code==200){
                this.setState({
                    jjlxrData:res.data
                },()=>{
                    this.getViewData();
                })
            }else{
                message.error("获取紧急联系人数据失败!")
            }
            
        });
        }

    getViewData=()=>{
        console.log("initFormData----------",this.props.initFormData);
        let xsid = this.props.initFormData.XSID;
        const {jjlxrData} = this.state;
        console.log("jjlxrData",jjlxrData);
        NHFetch('api/zhxg-yxwz/newStudent/getJtcyInfoByXsid',"get",{xsid:xsid}).then(res=>{
            if(res){
                console.log("返回字段");
                if(res.code==200){
                    let List = [];
                    let data =res.data;
                    data.map((item,index)=>{
                        jjlxrData.map((item2,index2)=>{
                            console.log(item,item2);
                                if(item.gx==item2.VALUE){
                                    item['gxmc'] = item2.LABEL;
                                    List.push(item);
                                }
                        })
                    })
                    console.log("data----------",List);
                    this.setState({
                        viewData:List
                    })
                }
            }
        })
    }

    // 下载文件
    handlePreview = (fjmc, fjid) => {
        window.open(`api/docrepo/download/file?attachmentId=${fjid}`);
    };

    render() {
        const initFormData = this.props.initFormData;
        const {viewData} = this.state;
        return (
            <div>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={2} style={{textAlign:'right'}}> 姓名：</Col>
                    <Col span={4}>{initFormData.XM}</Col>
                    <Col span={2} style={{textAlign:'right'}}>性别：</Col>
                    <Col span={4}>{initFormData.XB}</Col>
                    <Col span={2} style={{textAlign:'right'}}>学号：</Col>
                    <Col span={4}>{initFormData.XH}</Col>
                    <Col span={2} style={{textAlign:'right'}}> 出生年月：</Col>
                    <Col span={4}>{initFormData.CSRQ}</Col>
                </Row>
                {/* <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>学号：</Col>
                    <Col span={8}>{initFormData.XH}</Col>
                    <Col span={4} style={{textAlign:'right'}}> 出生年月：</Col>
                    <Col span={8}>{initFormData.XH}</Col>
                </Row> */}
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={2} style={{textAlign:'right'}}>学院：</Col>
                    <Col span={4}>{initFormData.BMMC}</Col>
                    <Col span={2} style={{textAlign:'right'}}>专业：</Col>
                    <Col span={4}>{initFormData.ZYMC}</Col>
                    <Col span={2} style={{textAlign:'right'}}>籍贯：</Col>
                    <Col span={4}>{initFormData.JG}</Col>
                    <Col span={2} style={{textAlign:'right'}}>民族：</Col>
                    <Col span={4}>{initFormData.MZ}</Col>
                </Row>
                {/* <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>籍贯：</Col>
                    <Col span={8}>{initFormData.BMMC}</Col>
                    <Col span={4} style={{textAlign:'right'}}>民族：</Col>
                    <Col span={8}>{initFormData.ZYMC}</Col>
                </Row> */}
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={2} style={{textAlign:'right'}}>政治面貌：</Col>
                    <Col span={4}>{initFormData.ZZMMMC}</Col>
                    <Col span={2} style={{textAlign:'right'}}>联系电话：</Col>
                    <Col span={4}>{initFormData.SJHM}</Col>
                    <Col span={2} style={{textAlign:'right'}}>邮政编码：</Col>
                    <Col span={4}>{initFormData.YZBM}</Col>
                    <Col span={2} style={{textAlign:'right'}}>家庭地址：</Col>
                    <Col span={4}>{initFormData.JTDZ}</Col>
                </Row>
                {/* <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>邮政编码：</Col>
                    <Col span={8}>{initFormData.BJMC}</Col>
                    <Col span={4} style={{textAlign:'right'}}>家庭地址：</Col>
                    <Col span={8}>{initFormData.ND}</Col>
                </Row> */}
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={2} style={{textAlign:'right'}}>户口类型：</Col>
                    <Col span={4}>{initFormData.ZDYHKLX?(initFormData.ZDYHKLX=='01'?"农业户口":(initFormData.ZDYHKLX=='02'?"非农业户口":"")):""}</Col>
                    <Col span={2} style={{textAlign:'right'}}>生源地：</Col>
                    <Col span={4}>{initFormData.ZDYSYD?(initFormData.ZDYSYD=='01'?"深圳市内":(initFormData.ZDYSYD=='02'?"省内市外":(initFormData.ZDYSYD=='03'?"省外":""))):""}</Col>
                    <Col span={2} style={{textAlign:'right'}}>办理原因：</Col>
                    <Col span={4}>{initFormData.BLYY}</Col>
                    <Col span={2} style={{textAlign:'right'}}>贷款方式：</Col>
                    <Col span={4}>{initFormData.DKLXMC}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={2} style={{textAlign:'right'}}>申请理由：</Col>
                    <Col span={4}>{initFormData.SQSM}</Col>
                    <Col span={2} style={{textAlign:'right'}}>办理时间：</Col>
                    <Col span={4}>{initFormData.BLSJ}</Col>
                </Row>
                {initFormData.DKLXMC=="生源地贷款"&&<Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={2} style={{textAlign:'right'}}>办理金额：</Col>
                    <Col span={4}>{initFormData.BLJE}元</Col>
                    <Col span={2} style={{textAlign:'right'}}>贷款银行：</Col>
                    <Col span={4}>{initFormData.DKYHMC}</Col>
                    <Col span={2} style={{textAlign:'right'}}>6位数回执校验码：</Col>
                    <Col span={4}>{initFormData.HZJYM}</Col>
                </Row>}
                    <div style={{margin:"10px"}}>
                        <span style={{color:"#1890ff",fontSize:"24px",fontWeight:"bold",height:"42px",padding:'10px'}}>|</span>
                        <span style={{fontSize:"16px"}}>家庭成员情况</span>
                        {viewData&&viewData.length<=0 &&<span style={{fontSize:"16px"}}>：暂无家庭成员信息</span>}
                    </div>
                    { viewData&&viewData.length>0 &&<div style={{width:"90%",margin:"0 auto"}}>
                        <Row style={{fontSize:'14px',lineHeight:'1.5'}}>
                            <Col span={6} style={{textAlign:'center',border:"1px solid #e8e8e8",height:"42px",lineHeight:"42px"}}>关系</Col>
                            <Col span={6} style={{textAlign:'center',border:"1px solid #e8e8e8",height:"42px",lineHeight:"42px"}}>姓名</Col>
                            <Col span={6} style={{textAlign:'center',border:"1px solid #e8e8e8",height:"42px",lineHeight:"42px"}}>工作单位及职务</Col>
                            <Col span={6} style={{textAlign:'center',border:"1px solid #e8e8e8",height:"42px",lineHeight:"42px"}}>联系电话</Col>
                        </Row>
                        <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                            {
                                viewData&&viewData.length>0 &&viewData.map(item=>{
                                    return (<div>
                                        <Col span={6} style={{textAlign:'center',border:"1px solid #e8e8e8",height:"42px",lineHeight:"42px"}}>{item.gxmc}</Col>
                                        <Col span={6} style={{textAlign:'center',border:"1px solid #e8e8e8",height:"42px",lineHeight:"42px"}}>{item.xm}</Col>
                                        <Col span={6} style={{textAlign:'center',border:"1px solid #e8e8e8",height:"42px",lineHeight:"42px"}}>{item.gzxxdw}</Col>
                                        <Col span={6} style={{textAlign:'center',border:"1px solid #e8e8e8",height:"42px",lineHeight:"42px"}}>{item.lxfs}</Col>
                                    </div>)
                                })
                            }
                        </Row>
                    </div>}
                {/* <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>班级：</Col>
                    <Col span={8}>{initFormData.BJMC}</Col>
                    <Col span={4} style={{textAlign:'right'}}>年度：</Col>
                    <Col span={8}>{initFormData.ND}</Col>
                </Row> */}
                {/* <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>办理金额：</Col>
                    <Col span={8}>{initFormData.BLJE}元</Col>
                    <Col span={4} style={{textAlign:'right'}}>办理时间：</Col>
                    <Col span={20}>{initFormData.BLSJ}</Col>
                </Row> */}
                {/* <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>办理原因：</Col>
                    <Col span={8}>{this.state.blyy}</Col>
                    <Col span={4} style={{textAlign:'right'}}>贷款方式：</Col>
                    <Col span={8}>{initFormData.DKLXMC}</Col>
                </Row> */}
                {/* <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>贷款银行：</Col>
                    <Col span={8}>{initFormData.DKYHMC}</Col>
                    <Col span={4} style={{textAlign:'right'}}>6位数回执校验码：</Col>
                    <Col span={8}>{initFormData.HZJYM}</Col>
                </Row> */}
                {/* <Row gutter={24}>
                    <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                        style={{color: 'rgba(0, 0, 0, 0.85)'}}>材料证明&nbsp;: </span></Col>
                    <Col span={20}>
                        {this.state.fj.map((elem, index) => {
                            return (
                                <div style={{marginBottom: '20px'}}>
                                    <a onClick={() => {
                                        this.handlePreview(elem['fjmc'], elem['fjid']);
                                    }}>{elem['fjmc']}</a>
                                </div>
                            )
                        })
                        }
                    </Col>
                </Row> */}
                {initFormData.SJLY=='2' && <div>
                    <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                        <Col span={4} style={{textAlign:'right'}}>审核状态：</Col>
                        <Col span={8}>{initFormData.SHZTMC}</Col>
                        <Col span={4} style={{textAlign:'right'}}>审核时间：</Col>
                        <Col span={8}>{initFormData.SHSJ}</Col>
                    </Row>
                    <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                        <Col span={4} style={{textAlign:'right'}}>审核意见：</Col>
                        <Col span={20}>{initFormData.SHYJ}</Col>
                    </Row>
                </div>}
            </div>
        );
    }
}

export default ViewForm;


// WEBPACK FOOTER //
// ./components/swbl/szjdLstd/ViewForm.js